var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"img",style:({ backgroundImage: `url('${_vm.imageSrc}')` })}),_c('div',{staticClass:"banner-filter"}),_c('h1',[_vm._v(_vm._s(_vm.header))])])
}
var staticRenderFns = []

export { render, staticRenderFns }